import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

// The agent loader code executes immediately on instantiation.
export default function renderNewRelic() {
    // NREUM options added in __new_relic.tpl.php
    window?.NREUM && new BrowserAgent(window.NREUM);
}
